import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { ConfigService } from "../config/config.service";

@Injectable({
  providedIn: "root",
})
export class MobileDataService {
  public insets: any;
  public allGamesArray: any;
  public keyWordList: any;
  public mobileBottomKeyWordList: any[] = [];
  public mobileTopKeywordList: any[] = [];
  public mobileCasinoKeywordDeepLinkData: [] = null;
  public hiddenKeywordList:any;

  public defaultKeyword = {
    topKeyword: null,
    bottomKeyword: "Home",
  };
  private _mobileCasinoDeeplink: BehaviorSubject<any> = new BehaviorSubject(null);
  _mobileLobbyKeyword: BehaviorSubject<any> = new BehaviorSubject(
    this.defaultKeyword
  );
  constructor(
    private config: ConfigService,
  ) {}

  setLobbiesList(casinoLobbies, isAuthenticated) {
    if (casinoLobbies) {
      let mainLobbies = casinoLobbies.filter((l) => l.placement === "MAIN");
      let bottomLobbies = casinoLobbies.filter((l) => l.placement === "BOTTOM");

      
      if (bottomLobbies.length > 0){
        
        this.setBottomKeywordList(bottomLobbies[0].keywordInfo);
      }
       
      if (mainLobbies.length > 0) {
        //Seprate out list for Hidden and non-Hidden Casino category for Mobile Apps
        let mainLobbiesWithoutHidden = mainLobbies[0].keywordInfo.filter((k) => k.hide_keyword === false);
        let mainLobbiesWithHidden = mainLobbies[0].keywordInfo.filter((k) => k.hide_keyword === true);
        this.setHiddenKeywordListMobile(mainLobbiesWithHidden);
        if(!isAuthenticated) {
          this.updateKeywordListBasedOnAuth(mainLobbiesWithoutHidden)
        } else {
          this.setTopKeywordList(mainLobbiesWithoutHidden);
        }
      }
    }
  }

  private updateKeywordListBasedOnAuth(KeyWordList): any {
    if(KeyWordList) {
      const authBasedKeywords = this.config.getConfig()["FEATURE_AUTH_KEYWORDS"] ?? ["FAVOURITEGAMESCASINODESKTOPWEBNJMAIN", "FAVOURITEGAMESCASINOMOBILEWEBNJMAIN"];
      let filteredKeyWordList = KeyWordList.filter((f) => !authBasedKeywords.includes(f.keyword_code));
      this.setTopKeywordList(filteredKeyWordList);
    }
  }

  getBottomKeywordList() {
    return this.mobileBottomKeyWordList;
  }

  getTopKeywordList() {
    return this.mobileTopKeywordList;
  }

  setBottomKeywordList(keyWordList) {
    this.mobileBottomKeyWordList = keyWordList;
  }

  setTopKeywordList(keyWordList) {
    this.mobileTopKeywordList = keyWordList;
  }

  setMobileLobbyKeyword(SelectedKeyword) {
    this._mobileLobbyKeyword.next(SelectedKeyword);
  }
  getMobileLobbyKeyword() {
    return this._mobileLobbyKeyword;
  }

  sendExternalSelection(selection) {
    this.setMobileLobbyKeyword({
      topKeyword: null,
      bottomKeyword: selection,
    });
  }

  setMobileAppCasinoKeywordDeepLink(data){
    this.mobileCasinoKeywordDeepLinkData = data;
  }

  getMobileAppCasinoKeywordDeepLink(){
    return this.mobileCasinoKeywordDeepLinkData;
  }

  public setHiddenKeywordListMobile(list:any){
    this.hiddenKeywordList = list;
  }

  public getHiddenKeywordListMobile(){
    return this.hiddenKeywordList;
  }

  setMobileCasinoDeeplink(deeplinkValue) {
    this._mobileCasinoDeeplink.next(deeplinkValue);
  }
  getMobileCasinoDeeplink() {
    return this._mobileCasinoDeeplink;
  }
}
